import React from "react";
import TowerIcon from "@assets/img/structures/tower.svg?react";
import TowerPlateIcon from "@assets/img/structures/tower_plates.svg?react";
import { Structure } from "@shared/Map/objects/structures/Structure";
import { BuildingObject } from "@shared/Map/types";

interface SvgTowerProps {
	tower: BuildingObject;
}

const Tower: React.FC<SvgTowerProps> = (props) => {
	if (props.tower.life == 0) return null;

	return (
		<Structure
			// highlight={props.highlight}
			highlight={false}
			position={props.tower.position}
			teamId={props.tower.teamId}
			show={props.tower.life > 0}
			size={800}
		>
			<TowerIcon width={800} height={800} />
			{props.tower.hasShield && (
				<>
					<TowerPlateIcon width={800} height={800} />
					<text
						x={400}
						y={460}
						textAnchor={"middle"}
						alignmentBaseline={"middle"}
						fill={"currentColor"}
						fontSize={300}
					>
						{props.tower.life}
					</text>
				</>
			)}
		</Structure>
	);
};

export { Tower };
